import React from "react";
import { IconInfoCircleFilled } from "@tabler/icons-react";

const ModalEarlyBird = (props) => {
  return (
    <>
      <div className="row mb-3">
        <div
          className="card border-warning"
          style={{ backgroundColor: "#FFF3CD", marginBottom: "15px" }}
        >
          <div className="card-body">
            <div className="row mb-3">
              <div className="col-12 d-flex">
                <div className="col-lg-2 col-12">
                  <IconInfoCircleFilled
                    width="60px"
                    height="60px"
                    className="text-warning"
                  />
                </div>
                <div className="col-lg-10 col-12">
                  <div className="row">
                    <h4 className="text-warning">Selamat!</h4>
                  </div>
                  <div className="row">
                    <p style={{ fontSize: "12px" }}>
                      Anda mendapatkan <b>Diskon Early Bird</b> untuk program
                      yang telah anda pilih.<br></br>Untuk mengaktifkan diskon
                      ini, silahkan ikuti langkah-langkah berikut.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 mb-3">
                <h4>1. Pakai Diskon Early Bird</h4>
                <p style={{ fontSize: "12px" }}>
                  Pada halaman konfirmasi data pendaftaran, pastikan anda{" "}
                  <b>mencentang kotak opsi "Early Bird"</b> di bagian bawah
                  halaman konfirmasi.
                </p>
              </div>
              <div className="col-12 mb-4">
                <h4>2. Selesaikan Pembayaran</h4>
                <p style={{ fontSize: "12px" }}>
                  Selesaikan pembayaran anda melalui <b>platform pembayaran</b>{" "}
                  yang kami sediakan, sebelum due date diskon berakhir{" "}
                  <b>(H-5 sebelum program dilaksanakan)</b>.
                </p>
              </div>
              <div className="col-12">
                <h4>Catatan</h4>
                <p style={{ fontSize: "12px" }}>
                  Untuk perusahaan yang{" "}
                  <b>
                    membayar setelah program selesai, mohon "Lewati Early Bird"
                  </b>{" "}
                  dan <b>tidak mencentang kotak opsi "Early Bird"</b>. Silahkan
                  upload{" "}
                  <b>
                    Guarantee Letter (GL) setelah menyelesaikan pendaftaran.
                  </b>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end">
          <button
            className="btn btn-outline-success"
            style={{ marginRight: "15px" }}
            onClick={props.activateEarlyBird}
          >
            Pakai Early Bird
          </button>
          &nbsp;
          <button className="btn btn-success" onClick={props.skipEarlyBird}>
            Lewati Early Bird
          </button>
        </div>
      </div>
    </>
  );
};

export default ModalEarlyBird;
